import { isBoostPlayerBonus } from "./typeGuards";
const disclaimerKeyByType = {
    EARLY_WIN: "CashOutEarlyWinDisclaimer",
    QUALIFYING_BET: "CashOutQualifyingBetDisclaimer",
    FREE_BET: "FreeBetCashOutDisclaimer",
};
export function getCashOutDisclaimer(cashOut, playerBonus, dictionary) {
    let result = "";
    if (Boolean(cashOut)) {
        if ((playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "GUARANTEED_PAYOUT") {
            return dictionary.myBetsDictionary.GhostLegActive;
        }
        if (isBoostPlayerBonus(playerBonus)) {
            result = dictionary.myBetsDictionary.CashOutBonusDisclaimer;
        }
        const disclaimerKey = (playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) && disclaimerKeyByType[playerBonus.type];
        if (disclaimerKey) {
            result = dictionary.myBetsDictionary[disclaimerKey];
        }
    }
    return result;
}
//# sourceMappingURL=getCashOutDisclaimer.js.map